import React, { useEffect, useState } from "react";
import { Row, SaveTable } from "../DataTable.jsx";

import update from "immutability-helper";

import { OPERATING_MODE } from "../const.js";
import { useHwaddrAndNetworkIdFromRouter, usePanelUpdateAPI, useZones } from "../store/panelsSlice.js";
import { useHwaddrFromRouter } from "../store/sitesSlice.js";
import { useSiteConnected } from "../store/connectionSlice.js";

export const ZoneEditor = (props) => {
    const zones = useHwaddrAndNetworkIdFromRouter(useZones);
    const zoneFromDb = zones[props.match.params.id];
    const enabled = useHwaddrFromRouter(useSiteConnected);
    const [isDirty, setDirty] = useState(false);
    const [zone, setZone] = useState(zoneFromDb);

    const { updateZone } = usePanelUpdateAPI();

    useEffect(() => {
        if (!isDirty && zone !== zoneFromDb) {
            setZone(zoneFromDb);
        }
    }, [isDirty, zoneFromDb]);

    let bind = (key) => ({
        value: zone[key],
        onChange: (ev) => {
            setDirty(true);
            setZone(update(zone, { [key]: { $set: ev.target.value } }));
        },
    });

    if(zone == null){
        return (<p>Loading zone...</p>);
    }
    return (
        <SaveTable
            disabled={!isDirty}
            onSave={() => {
                updateZone(zone.id, zone.name, zone.mode).then(() => {
                    setDirty(false);
                });
            }}
        >
            <Row label="ID">{zone.id}</Row>
            <Row label="Name">
                <input
                    className="form-control"
                    type="text"
                    disabled={!enabled}
                    {...bind("name")}
                    maxLength={47}
                />
            </Row>
            <Row label="Mode">
                <select className="form-control" disabled={!enabled} {...bind("mode")}>
                    {Object.keys(OPERATING_MODE)
                        .filter((k) => k != "MODE_NONE")
                        .map((k) => (
                            <option key={k} value={k}>
                                {OPERATING_MODE[k]}
                            </option>
                        ))}
                </select>
            </Row>
        </SaveTable>
    );
};
